import request from '@/utils/request'

const getCurrentUserTrainings = () => {
  return request({
    url: `${process.env.VUE_APP_ALIEXPRESS_API}/Training/GetCurrentUserTrainings`,
    method: 'get'
  })
}

export default {
  getCurrentUserTrainings
}
